module.exports = __webpack_public_path__ + "static/img/title_Frequently.a75edec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/title_Frequently.png
// module id = y8dn
// module chunks = 0